import {Carousel, Slide} from 'vue-carousel';
import VueGallery from 'vue-gallery';
import {mapMutations, mapGetters, mapActions} from "vuex";

export default {
  name: 'gallery-product',
  data() {
    return {
      currentSlideMain: 0,
      currentSlideTumble: 0,
      disablePrev: false,
      disableNext: false,
      index: null,
    }
  },
  props: {
    items: {
      type: Array,
      default: []
    }

  },
  components: {
    Carousel,
    'gallery': VueGallery,
    Slide
  },
  computed: {
    ...mapGetters({
      product: 'card/product',
    }),
    imageLinks(){
      return this.items.map(e => e.link)
    }
  },
  mounted() {
    this.setClassTumble(this.items);
  },
  methods: {
    changeArrow(value) {
      const carousel = this.$refs['slider-items'];
      const carousel2 = this.$refs['slider-tumble'];

      const currentPage = carousel.currentPage;
      const currentPage2 = carousel2.currentPage;

      const pageCount = carousel.pageCount;
      const pageCount2 = carousel2.pageCount;
      if (value === 'prev') {
        currentPage !== 0 ? carousel.goToPage(currentPage - 1) : '';
        currentPage2 !== 0 ? carousel2.goToPage(currentPage2 - 1) : '';
      } else {
        currentPage < pageCount - 1 ? carousel.goToPage(currentPage + 1) : '';
        currentPage2 < pageCount2 ? carousel2.goToPage(currentPage2 + 1) : '';
      }
    },
    goToSlide(index) {
      const carousel = this.$refs['slider-items'];
      const carousel2 = this.$refs['slider-tumble'];
      carousel.goToPage(index);
      carousel2.goToPage(index);
    },
    pageChangeMain(slide) {
      this.currentSlideMain = slide;
      const carousel = this.$refs['slider-tumble'];
      carousel.goToPage(slide)
    },
    onChangeSlider(index){
      this.index = index
    },
    pageChangeTumble(slide) {
      this.currentSlideTumble = slide;
      const carousel = this.$refs['slider-items'];
      carousel.goToPage(slide)
    },
    setClassTumble(items) {
      return `card-gallery__tumble-${items.length}`
    }
  }
}
